import { applicationInternalReducer as applicationinternal } from 'app-modules/application/reducers';
import { guideInternalReducer as guideinternal } from 'app-modules/guide/reducers';
import { uiReducer as ui } from 'app-modules/ui/reducers';
import { playerInternalReducer as playerinternal } from 'app-modules/player/reducers';
import { triviaReducer as trivia } from 'app-modules/trivia/reducers';
import { chatReducer as chat } from 'app-modules/chat/reducers';
import { wamDialogsReducer as wamDialogs } from 'app-modules/wamDialogs/reducers';
import { embedReducer as embed } from 'app-modules/embed/reducers';
import { desktopReducer as desktop } from 'app-modules/desktop/reducers';
import { vodReducer as vod } from 'app-modules/vod/reducers';
import { trendingReducer as trending } from 'app-modules/trending/reducers';
import { viralReducer as viral } from 'app-modules/viral/reducers';
import { createWhitelistFilter } from 'redux-persist-transform-filter';

export const customPersistConfig = {
  key: 'root',
  whitelist: ['playerinternal'],
  transforms: [createWhitelistFilter('playerinternal', ['captionsSettings', 'captionInUseIndex'])],
};

export const customReducers = {
  applicationinternal,
  guideinternal,
  playerinternal,
  chat,
  ui,
  trivia,
  wamDialogs,
  embed,
  vod,
  desktop,
  trending,
  viral,
};
